import api from 'api'
import useSWR from 'swr'

/**
 * 取引先を取得するSWR
 */

export const useAssociableCustomer = ({
  ownerId,
  userId,
}: {
  ownerId?: string
  userId?: string
}) => {
  return useSWR<Customer>(
    userId ? '/customers/associable_customer' : null,
    (key) =>
      api
        .get(key, {
          params: {
            owner_id: ownerId,
            user_id: userId,
          },
        })
        .then((res) => res.data),
    {
      revalidateOnFocus: false,
    },
  )
}
